/**
 * Color palette — hex values so alpha suffixes like `${color}cc` work in styled-components.
 */
export const colors = {
  light: {
    background: '#fafafa',
    foreground: '#0a0a0a',
    card: '#ffffff',
    cardForeground: '#0a0a0a',
    popover: '#ffffff',
    popoverForeground: '#0a0a0a',
    primary: '#0a0a0a',
    primaryForeground: '#ffffff',
    secondary: '#f5f5f5',
    secondaryForeground: '#0a0a0a',
    muted: '#f0f0f0',
    mutedForeground: '#737373',
    accent: '#f5f5f5',
    accentForeground: '#0a0a0a',
    destructive: '#ef4444',
    destructiveForeground: '#ffffff',
    success: '#16a34a',
    successForeground: '#ffffff',
    error: '#dc2626',
    errorForeground: '#ffffff',
    border: '#e5e5e5',
    input: '#e5e5e5',
    ring: '#0a0a0a',
    newsletter: {
      background: '#0a0a0a',
      foreground: '#ffffff',
      muted: '#ffffffb3',
      inputBackground: '#ffffff1a',
      inputBorder: '#ffffff33',
      inputPlaceholder: '#ffffff80',
      buttonBackground: '#ffffff',
      buttonForeground: '#0a0a0a',
    },
    category: {
      coral: '#ff6b6b',
      teal: '#4ecdc4',
      amber: '#ffb347',
      violet: '#9b59b6',
      emerald: '#2ecc71',
      rose: '#f43f5e',
      sky: '#0ea5e9',
      lime: '#84cc16',
    },
  },
  dark: {
    background: '#0f0f0f',
    foreground: '#f5f5f5',
    card: '#1a1a1a',
    cardForeground: '#f5f5f5',
    popover: '#1a1a1a',
    popoverForeground: '#f5f5f5',
    primary: '#f5f5f5',
    primaryForeground: '#0a0a0a',
    secondary: '#242424',
    secondaryForeground: '#f5f5f5',
    muted: '#2e2e2e',
    mutedForeground: '#a3a3a3',
    accent: '#2e2e2e',
    accentForeground: '#f5f5f5',
    destructive: '#7f1d1d',
    destructiveForeground: '#f5f5f5',
    success: '#22c55e',
    successForeground: '#0a0a0a',
    error: '#f87171',
    errorForeground: '#0a0a0a',
    border: '#333333',
    input: '#333333',
    ring: '#f5f5f5',
    newsletter: {
      background: '#1a1a1a',
      foreground: '#f5f5f5',
      muted: '#f5f5f5b3',
      inputBackground: '#ffffff14',
      inputBorder: '#ffffff2e',
      inputPlaceholder: '#f5f5f580',
      buttonBackground: '#f5f5f5',
      buttonForeground: '#0a0a0a',
    },
    category: {
      coral: '#ff6b6b',
      teal: '#4ecdc4',
      amber: '#ffb347',
      violet: '#9b59b6',
      emerald: '#2ecc71',
      rose: '#f43f5e',
      sky: '#0ea5e9',
      lime: '#84cc16',
    },
  },
};
